import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthenticationService } from '@app/services/authentication.service';

type AccessCheck = {
  roles?: string | string;
  permissions?: string | string[];
};


@Directive({
  selector: '[appHasAccess]',
  standalone: true
})
export class HasAccessDirective {

  private isVisible = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthenticationService
  ) {}

  @Input() set appHasAccess(access: AccessCheck | null) {
    let hasAccess = false;
    if (access?.roles) {
      hasAccess = this.authService.hasRole(access.roles);
    } else if (access?.permissions) {
      hasAccess = this.authService.hasAccessRight(access.permissions);
    }

    if (hasAccess && !this.isVisible) {
      this.isVisible = true;
      this.viewContainer.createEmbeddedView(this.templateRef); 
    } else if (!hasAccess && this.isVisible) {
      this.isVisible = false;
      this.viewContainer.clear();
    }
  }

}
